import React from 'react'
import loaderImg from '../../assets/Images/loader/loading-white.gif'
import '.././styles/GenricComponent.css'
function TinyWhiteLoader(props) {
    return (
        <>
            <div className="">
                <img className="tiny-loader" src={loaderImg} alt="Loading..." />
            </div>
        </>
    )
}

export default TinyWhiteLoader;